import React, { FC, useEffect, useState } from 'react'
import { Button, Card, Col, FloatingLabel, Form, Modal, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import DSCatUsuarios from '../../Services/Catalogos/CatUsuarios.Services'
import ICatUsuarios from '../../Interfaces/Catalogos/ICatUsuarios'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { BsFillPencilFill } from 'react-icons/bs'
import Clean from '../../images/Clean.png'
import loadingImg from '../../images/ajaxloader.gif'

interface IProps {}

export const CatUsuarios: FC<IProps> = (props) => {
  const mCatClientes = useSelector((state: RootState) => state.CatClientes.CatClientes)
  const mCatProveedores = useSelector((state: RootState) => state.CatProveedores.CatProveedores)
  const [DataUsuarios, setDataUsuarios] = useState<ICatUsuarios[]>([])
  const [IDUsuario, setIDUsuario] = useState(0)
  const [Usuario, setUsuario] = useState('')
  const [Nombre, setNombre] = useState('')
  const [TipoUsuario, setTipoUsuario] = useState(0)
  const [Search, setSearch] = useState('')
  const [SearchUser, setSearchUser] = useState('')
  const [showDialog, setShowDialog] = useState(false)
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatUsuarios) => row.id,
      sortable: true,
    },
    {
      name: 'Nombre',
      width: '250px',
      selector: (row: ICatUsuarios) => row.nombre,
      sortable: true,
    },
    {
      name: 'Usuario',
      width: '250px',
      selector: (row: ICatUsuarios) => row.usuario,
      sortable: true,
    },
    {
      name: 'Activo',
      width: '90px',
      selector: (row: ICatUsuarios) => (row.activo === 1 ? 'Si' : 'No'),
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatUsuarios) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (row: ICatUsuarios) => {
    setUsuario(row.usuario)
    setNombre(row.nombre)
    setTipoUsuario(row.tipoUsuario)
    setIDUsuario(row.id)
  }

  const saveForm = () => {
    setShowDialog(true)
    const data: ICatUsuarios = {
      id: IDUsuario,
      usuario: Usuario,
      contrasena: '',
      nombre: Nombre,
      tipoUsuario: TipoUsuario,
      idPerfil: 0,
      activo: 1,
    }
    DSCatUsuarios.Append(data)
      .then((response) => {
        cleanForm()
        loadUsers()
        setShowDialog(false)
      })
      .catch((e: Error) => {
        alert('Ocurrio un error' + e.message.toString())
      })
  }

  const loadUsers = () => {
    DSCatUsuarios.GetAll()
      .then((response) => {
        console.log(response.data)
        setDataUsuarios(response.data)
      })
      .catch((e: Error) => {
        alert('Ocurrio un error' + e.message.toString())
      })
  }

  const cleanForm = () => {
    setUsuario('')
    setNombre('')
    setTipoUsuario(0)
    setIDUsuario(0)
  }

  useEffect(() => {
    loadUsers()
  }, [])

  return (
    <div>
      <br />
      <Card>
        <Card.Body>
          <Row>
            <Col xs={6}>
              <Card style={{ backgroundColor: 'rgba(245, 245, 245, 0.4)' }}>
                <Card.Body>
                  <Row>
                    <Col xs={7}>
                      <FloatingLabel controlId='TxtNombre' label='Nombre' className='mb-3'>
                        <Form.Control
                          type='text'
                          placeholder='Nombre'
                          value={Nombre}
                          onChange={(e) => {
                            setNombre(e.target.value)
                          }}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={5}>
                      <FloatingLabel controlId='CmbTipoUsuario' label='Tipo de usuario'>
                        <Form.Select
                          aria-label='Tipo usuario'
                          value={TipoUsuario}
                          onChange={(e) => {
                            setTipoUsuario(parseInt(e.target.value))
                          }}
                        >
                          <option value='0'></option>
                          <option value='1'>Cliente</option>
                          <option value='2'>Proveedor</option>
                          <option value='3'>Usuario interno - Administrador</option>
                          <option value='4'>Usuario interno - Operaciones</option>
                        </Form.Select>
                      </FloatingLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col style={{ paddingTop: '15px' }}>
                      <img
                        src={Clean}
                        alt='Limpia formulario'
                        height='30'
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          cleanForm()
                        }}
                      />
                    </Col>
                    <Col xs={9}>
                      <FloatingLabel controlId='floatingInput' label='Usuario (correo@empresa.com)' className='mb-3'>
                        <Form.Control
                          type='text'
                          placeholder='name@empresa.com'
                          value={Usuario}
                          onChange={(e) => {
                            setUsuario(e.target.value)
                          }}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col xs={2} style={{ paddingTop: '10px' }}>
                      <Button
                        onClick={() => {
                          saveForm()
                        }}
                      >
                        Guardar
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={6}>
              <Card style={{ backgroundColor: 'rgba(245, 245, 245, 0.4)' }}>
                <Card.Body>
                  <Row>
                    <Col>
                      <Form.Control
                        type='text'
                        id='Search'
                        aria-describedby='passwordHelpBlock'
                        value={Search}
                        onChange={(e) => {
                          setSearch(e.target.value)
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ paddingTop: '5px' }}>
                    <Col xs={12}>
                      <div className='divTipoCatalogo'>
                        {TipoUsuario === 1
                          ? mCatClientes
                              .filter((c) => c.cliente.toLocaleLowerCase().includes(Search.toLocaleLowerCase()))
                              .map((c) => {
                                return (
                                  <Form.Check
                                    type='checkbox'
                                    id={`default-${c.id}`}
                                    label={`${c.cliente}`}
                                    style={{ textAlign: 'left', fontWeight: 'normal' }}
                                  />
                                )
                              })
                          : null}
                        {TipoUsuario === 2
                          ? mCatProveedores
                              .filter((c) => c.proveedor.toLocaleLowerCase().includes(Search.toLocaleLowerCase()))
                              .map((c) => {
                                return (
                                  <Form.Check
                                    type='checkbox'
                                    id={`default-${c.id}`}
                                    label={`${c.proveedor}`}
                                    style={{ textAlign: 'left', fontWeight: 'normal' }}
                                  />
                                )
                              })
                          : null}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={12}>
              <Form.Control
                type='text'
                size='sm'
                placeholder='Search...'
                onChange={(e: any) => {
                  setSearchUser(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: '5px' }}>
            <Col xs={12}>
              <Card>
                <DataTable
                  noHeader
                  defaultSortFieldId={'id'}
                  defaultSortAsc={true}
                  striped={true}
                  dense={true}
                  paginationPerPage={10}
                  pagination
                  highlightOnHover
                  columns={columnsConcepts}
                  data={DataUsuarios.filter(function (row: ICatUsuarios) {
                    return (
                      row.usuario.toLocaleLowerCase().includes(SearchUser.toLocaleLowerCase()) ||
                      row.nombre.toLocaleLowerCase().includes(SearchUser.toLocaleLowerCase())
                    )
                  })}
                  pointerOnHover
                />
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Modal
        show={showDialog}
        onHide={() => {
          setShowDialog(false)
        }}

      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={loadingImg} style={{ width: '25%', height: '25%' }} alt='proccessing' />
        Generando acceso y enviando correo...
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  )
}
